import { Injectable } from "@angular/core";
import { CanDeactivate, Router } from "@angular/router";
import { ConfiguracionNotificacionesComponent } from "../views/perfil/configuracion-notificaciones/configuracion-notificaciones.component";

@Injectable()
export class UnsavedChangesGuard implements CanDeactivate<ConfiguracionNotificacionesComponent>{

  constructor(private _router: Router) { }

  working: boolean = false;

  canDeactivate(component: ConfiguracionNotificacionesComponent) {
    if (this.working == true) {
      return window.confirm("Si continua, perdera los cambios.");
    }
    else {
      return true;
    }
  }

  changeState(state: boolean) {
    this.working = state;
  }
}